import { memo } from "react";
import { TextField } from "@mui/material";

interface IImageInputProps {
    value: string;
    onChange: (value: string) => void;
}

const ImageInput = memo(({ value, onChange }: IImageInputProps) => (
    <TextField placeholder="Enter a caption (Optional)" value={value} onChange={(e) => onChange(e.target.value)} fullWidth multiline />
));

export default ImageInput;
